module.exports = __webpack_public_path__ + "static/media/mastercardlogo.0458216c.svg";